<template>
    <ion-radio-group aira-label="recipe-name" mode="md" :value="localModelValue">
        <ion-item v-for="(option, idx) in sorted" :key="componentKey + idx" button lines="none" @click="radioClick(option?.[keyName])" :class="{ dense: dense }">
            <div class="ion-text-capitalize interstate-bold ion-text-wrap">{{ option?.[keyName] }}</div>
            <ion-radio slot="start" :value="option?.[keyName]" :class="{ left, right }" />
        </ion-item>
    </ion-radio-group>
</template>

<script lang="ts">
import { defineComponent, computed, nextTick } from 'vue';
import { IonRadioGroup, IonRadio, IonItem } from '@ionic/vue';
export default defineComponent({
    props: {
        modelValue: {
            type: Object, // Change the type to Object
            default: () => ({ value: null }), // Provide a default object
        },
        componentKey: {
            type: String,
            default: Date.now() + '',
        },
        keyName: { type: String, required: true, default: 'name' },
        options: { type: Array, required: true },
        dense: Boolean,
        left: Boolean,
        right: Boolean,
        defaultFirst: Boolean,
        sortKey: String,
        forceReselect: Boolean,
    },
    components: { IonRadioGroup, IonRadio, IonItem },
    setup(props, { emit }) {
        const localModelValue = computed({
            get: () => props?.modelValue?.[props.keyName], // Access the value property
            set: (newValue) => {
                //@ts-ignore
                const newVal = sorted.value.find((d) => d?.[props?.keyName].toLowerCase().includes(newValue?.toLowerCase())) || null;
                const modelValueUpdate = { ...newVal };

                // Emit the function that returns an object
                if (modelValueUpdate) emit('update:modelValue', { ...newVal });
            },
        });

        const radioClick = (option) => {
            localModelValue.value = option;
            if (option?.isCustomPizza) emit('update', option);
        };

        // Sort options
        //@ts-ignore
        const sorted = computed(() => (props.sortKey ? [...props.options].sort((a, b) => a[props.sortKey] - b[props.sortKey]) : props.options));

        nextTick(async () => {
            if (props.forceReselect && localModelValue.value) {
                const temp = localModelValue.value;
                localModelValue.value = null;
                setTimeout(() => {
                    localModelValue.value = temp;
                });
            }
        });

        return { localModelValue, sorted, radioClick };
    },
});
</script>

<style scoped>
.dense {
    max-height: 45px;
    min-height: 45px;
    display: flex;
}
.dense.item-radio-checked.altLabel {
    max-height: unset !important;
    overflow: initial;
    margin-top: 11px;
    z-index: 0;
}
.dense.item-radio-checked.altLabel > ion-radio {
    align-self: start;
    top: 6px;
}

.dense > * {
    margin: 0;
}
.dense > ion-radio {
    margin-right: 16px;
}
ion-item {
    --inner-padding-end: 0;
}
.left.radio-checked::part(mark) {
    border-bottom-left-radius: 34px;
    border-top-left-radius: 34px;
    width: 14px !important;
    left: 0;
    position: absolute;
}
.right.radio-checked::part(mark) {
    border-bottom-right-radius: 34px;
    border-top-right-radius: 34px;
    width: 14px !important;
    right: 0;
    position: absolute;
}
@media screen and (max-width: 960px) {
    .dense > ion-radio {
        margin-right: 8px !important;
    }
    .dense {
        font-size: 1em;
    }
}
ion-radio {
    width: 35px;
    height: 35px;
}
</style>
